export default "__VITE_ASSET__DHBYXmc7__"